export default {
    appNewView: '/gateway/manageBedrock/free/newscs/appNewView', // 新闻详情
}



// WEBPACK FOOTER //
// ./src/news/detail/api.js